export default __webpack_public_path__ + "static/media/97t.609b77bd.jpg";